import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { extractFilenameFromHeaders, fillPlaceholders } from '@skylab-shared/utils';

export interface KsefGetDocumentXmlQueryParams {
    id: number;
}

export interface KsefGetDocumentXmlQueryResult {
    readonly file: Blob;
    readonly filename: string;
    readonly xml: string;
}

export class KsefGetDocumentXmlQuery extends Query<KsefGetDocumentXmlQueryResult> {
    public constructor(public readonly params: KsefGetDocumentXmlQueryParams) {
        super();
    }
}

export class KsefGetDocumentXmlQueryHandlerBase implements QueryHandler<KsefGetDocumentXmlQuery> {
    private static Url = TaggedUrl.join('eInvoices/:id/xml/export', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync({ params }: KsefGetDocumentXmlQuery): Promise<KsefGetDocumentXmlQueryResult> {
        const url = fillPlaceholders(KsefGetDocumentXmlQueryHandlerBase.Url, { id: params.id });
        const response = await this.http.get<string>(url, {
            transformResponse: []
        });

        return {
            xml: response.data,
            file: new Blob([response.data], {type: 'text/xml'}),
            filename: extractFilenameFromHeaders(response) ?? ''
        };
    }
}

export class KsefGetDocumentXmlToPreviewQuery extends Query<KsefGetDocumentXmlQueryResult> {
    public constructor(public readonly params: KsefGetDocumentXmlQueryParams) {
        super();
    }
}

export class KsefGetDocumentXmlToPreviewQueryHandlerBase implements QueryHandler<KsefGetDocumentXmlToPreviewQuery> {
    private static Url = TaggedUrl.join('eInvoices/:id/xml', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync({ params }: KsefGetDocumentXmlQuery): Promise<KsefGetDocumentXmlQueryResult> {
        const url = fillPlaceholders(KsefGetDocumentXmlToPreviewQueryHandlerBase.Url, { id: params.id });
        const response = await this.http.get<string>(url, {
            transformResponse: []
        });

        return {
            xml: response.data,
            file: new Blob([response.data], {type: 'text/xml'}),
            filename: extractFilenameFromHeaders(response) ?? ''
        };
    }
}
